import { ref, computed, watch } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import store from '@/store'
import router from "@/router";
import ability from '@/libs/acl/ability'
import { debounce } from 'lodash'
import useFilterCounter from '@/components/Filters/useFiltersCount'

export default function useList() {
  const refListTable = ref(null)
  const toast = useToast()

  const tableColumns = [
    {
      label: 'bosch.description',
      key: 'description',
      sortable: false
    },
    {
      label: 'bosch.eventDefinition',
      key: 'event_definition',
      sortable: false
    },
    {
      label: 'bosch.deviceType',
      key: 'device_type',
      sortable: false
    },
    {
      label: 'bosch.deviceId',
      key: 'device_id',
      sortable: false
    },
    {
      label: 'bosch.deviceName',
      key: 'device_name',
      sortable: false
    },
    {
      label: 'bosch.alarmType',
      key: 'alarm_type',
      sortable: true
    },
    {
      label: 'bosch.dispatchAlarm',
      key: 'dispatch_alarm',
      sortable: true
    },
  ]

  if (ability.can('update', 'BoschPanel') || ability.can('delete', 'BoschPanel')) {
    tableColumns.splice(0, 0, { label: 'actions.name', key: 'actions' })
  }

  const perPage = ref(10)
  const totalList = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('description')
  const isSortDirDesc = ref(false)
  const idPanel = router.currentRoute.params.id_panel;

  store.dispatch('type_alarm/getAll')
  store.dispatch('bosch_events_definition/getAll')

  const eventCode = ref([])
  const eventDefinitionOptions = computed(() => store.getters['bosch_events_definition/getSelectedItems'] || [])

  const typeAlarm = ref([])
  const alarmTypeOptions = computed(() => store.getters['type_alarm/getSelectedItems'])

  const eventDefinitionOptionsFilter = ref(null);
  const eventCodeFilter = ref(null)
  const typeAlarmFilter = ref(null)
  const dispatchAlarmFilter = ref(null)
  const deviceTypeFilter = ref(null)
  const valueFilter = ref(null)
  const idBoschProfile = ref(parseInt(router.currentRoute.params.id_bosch_panel_profile))


  const dataMeta = computed(() => {
    const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalList.value,
    }
  })

  const fetchList = (ctx, callback) => {
    store.dispatch('bosch_rules/getAll', {
      q: searchQuery.value,
      max: perPage.value,
      'page[n]': currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      id_bosch_panel_profile: idBoschProfile.value,
      event_definition: eventDefinitionOptionsFilter.value,
      alarm_type: typeAlarmFilter.value,
      dispatch_alarm: dispatchAlarmFilter.value,
      device_type: deviceTypeFilter.value
    })
      .then(response => {
        callback(response.data)
        totalList.value = response.meta.total
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error obteniendo la información',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  const refetchData = () => {
    refListTable.value.refresh()
  }

  watch([currentPage, perPage], () => {
    refetchData()
  })

  watch([searchQuery], debounce(() => {
    refetchData()
  }, 500))

  const filters = ref({})
  const filtersCount = useFilterCounter(filters)

  const buildFilters = () => {
    filters.value = {
      event_definition: eventDefinitionOptionsFilter.value,
      alarm_type: typeAlarmFilter.value,
      dispatch_alarm: dispatchAlarmFilter.value,
      device_type: deviceTypeFilter.value
    }
    refetchData()
  }

  const clearSearchFilters = () => {
    eventDefinitionOptionsFilter.value = null;
    typeAlarmFilter.value = null;
    dispatchAlarmFilter.value = null;
    deviceTypeFilter.value = null;
    buildFilters()
  }

  return {
    tableColumns,
    perPage,
    currentPage,
    totalList,
    fetchList,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refListTable,

    idPanel,
    eventCode,
    eventDefinitionOptions,
    eventDefinitionOptionsFilter,
    typeAlarm,
    alarmTypeOptions,
    eventCodeFilter,
    typeAlarmFilter,
    dispatchAlarmFilter,
    deviceTypeFilter,
    valueFilter,

    refetchData,
    clearSearchFilters,
    buildFilters,
    filtersCount,

    idBoschProfile
  }
}
